import type { ExternalCrmMigrationResponse } from "@przezmorze/api-types";
import { przezmorzeBatchApi, throwMessageOnStatuses } from "../../api/api";

export type { ExternalCrmMigrationResponse };

export async function migrateCustomersToExternalCrm(): Promise<ExternalCrmMigrationResponse> {
  try {
    const response = await przezmorzeBatchApi.post<ExternalCrmMigrationResponse>("/external-crm/migration");
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [403, 502]);
  }
}
